<template>
  <div>
    <button
      @click="testVerifySepaDACH"
      class="dbc-gc-btn dbc-gc-btn--secondary c-registration-button my-xs mx-2xs"
    >
      *Test SEPA DACH-Region*
    </button>
    <button
      @click="testVerifySepaNonDACH"
      class="dbc-gc-btn dbc-gc-btn--secondary c-registration-button my-[1rem] mx-[0.5rem]"
    >
      *Test SEPA nicht-DACH-Region*
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  sepaVerifyTimestamp: string
}>()

const emit = defineEmits<{
  (e: 'submitPaymentData', paymentData: PaymentData | null): void
  (e: 'isEditable', isEditable: boolean): void
  (e: 'isSubmitted', isSubmitted: boolean): void
}>()

const isDACH = useState('isDACH')

const paymentResult = ref<PaymentData | null>(null)

const paymentData: any = {
  createdAt: 1609835909252,
  modifiedAt: 1609835909252,
  paymentInstrumentId: 'paymentinstrument_mhlhzy4zth',
  merchantPaymentInstrumentId: null,
  attributes: {
    iban: 'DE62888888880012345678',
    bic: '',
    accountHolder: 'JANE DOE',
    bankName: null,
    mandate: {
      mandateReference: '2bfe0eb4d46f46159b8ca7936f868a46',
      createdDateTime: 1609835870000,
      mandateText:
        'Ich ermächtige die Concardis GmbH, Helfman-Park 7 in 65760 Eschborn, GläubigerID DE82CC000000346626, Zahlungen von meinem Konto mittels SEPA-Lastschrift unter der Mandatsreferenz 2bfe0eb4d46f46159b8ca7936f868a46 einzuziehen. Zugleich weise ich mein Kreditinstitut an, die von Concardis GmbH auf mein Konto gezogenen SEPA-Lastschriften einzulösen. \n\n Verkürzung der Ankündigungsfrist: \n Die Frist für die Vorabinformation der SEPA-Lastschrift wird auf einen Tag verkürzt.',
      directDebitType: 'FIRST',
      allowedDirectDebitTypes: ['FIRST'],
    },
  },
  encrypted: false,
  origin: 'sepa',
  type: 'sepa',
  recurring: true,
}

const { locale } = useI18n()

function testVerifySepaDACH() {
  isDACH.value = true
  fetchSepaVerify(
    locale.value,
    'DE62888888880012345678',
    'Jane Doe',
    props.sepaVerifyTimestamp
  ).then((response) => {
    if (response.ok) {
      paymentResult.value = paymentData
      //@ts-ignore
      paymentResult.value.zahlungsReferenzId = response._data.data._id
      emit('isEditable', true)
      emit('submitPaymentData', paymentResult.value)
      window.open(response._data.data.redirecturl)
    }
  })
}

function testVerifySepaNonDACH() {
  isDACH.value = false
  paymentResult.value = paymentData
  //@ts-ignore
  paymentResult.value.attributes.iban = 'IT60X0542811101000000123456'

  emit('isSubmitted', true)
  emit('submitPaymentData', paymentResult.value)
}
</script>
